/**
 * Module dependencies.
 */

import { Me, useMe } from 'app/hooks/requests/use-me';
import { ProfileEditor } from './profile-editor';
import { Title } from 'app/components/atoms/title/title';
import { cookieStorage } from 'app/core/utils/cookie-storage';
import { useTranslation } from 'react-i18next';
import { useUpdatePassword } from 'app/hooks/requests/use-update-password';
import { useUpdateProfile } from 'app/hooks/requests/use-update-profile';
import React from 'react';

/**
 * Export `SettingsProfile` component.
 */

export function SettingsProfile(): JSX.Element {
  const [translate] = useTranslation();
  const { data: me } = useMe();
  const user = me ?? (cookieStorage.get('user') as Partial<Me> | undefined);

  const { mutateAsync: updateProfile } = useUpdateProfile();
  const { mutateAsync: updatePassword } = useUpdatePassword();

  return (
    <div className={'max-w-[640px] space-y-5'}>
      <Title>{translate('settings.menu.profile')}</Title>

      <ProfileEditor onSetPassword={updatePassword} onUpdate={updateProfile} user={user} />
    </div>
  );
}
